import { gql } from '@apollo/client';
import { TEAM_USERS } from '../fragments/team';
import { ONBOARDING_TASK } from '../fragments/onboarding';

export const getMinimalUserQuery = gql`
  query getMinimalUser {
    getUserV2 {
      user_id
      uuid
      is_whatis_admin
      is_workspace_admin
      profile_image
      real_name
      is_restricted
      is_ultra_restricted
      is_stranger
    }
  }
`;

export const getMinimalUserPinnedWhatisesQuery = gql`
  query getMinimalUserPinnedWhatises {
    getUserV2 {
      uuid
      pinned_whatises {
        whatis_id
        id
      }
    }
  }
`;

export const getUserQuery = gql`
  ${TEAM_USERS}
  ${ONBOARDING_TASK}
  query getUser {
    getUserV2 {
      id
      user_id
      uuid
      is_whatis_admin
      is_workspace_admin
      email
      profile_image
      real_name
      is_restricted
      is_ultra_restricted
      is_stranger
      notifications_enabled
      title
      pinned_whatises {
        whatis_id
        id
      }
      user_onboarding_progress {
        friendly_name
        description
        completed
        install_chrome_ext {
          ...OnboardingTaskFields
        }
        learn_create_request {
          ...OnboardingTaskFields
        }
      }
      team {
        channels {
          uuid
          name
          id
        }
        uuid
        team_id
        bot_user_id
        intro_message
        onboarding_progress {
          completed
          create_domains {
            ...OnboardingTaskFields
          }
          import_whatises {
            ...OnboardingTaskFields
          }
          customize_introduction_message {
            ...OnboardingTaskFields
          }
          setup_feed_channel {
            completed
            friendly_name
          }
        }
        days_remaining_in_trial
        is_enabled
        can_do_premium_things
        team_name
        notifications_channel_v2 {
          uuid
          name
          id
        }
        has_correct_permission_scopes
        restricted_mode
        throttled_searches {
          count
        }
        security_email
        payment_subscription {
          customer_id
          product_name_slug
          stripe_subscription_id
          subscription_name
          team_uuid
          cancel_at
          canceled_at
          cancel_at_period_end
          trial_end
        }
        ...TeamUsersFields
      }
    }
  }
`;

export const getExtensionUserQuery = gql`
  ${TEAM_USERS}
  query getExtensionUser {
    getUserV2 {
      user_id
      uuid
      is_whatis_admin
      is_workspace_admin
      profile_image
      real_name
      is_restricted
      is_ultra_restricted
      is_stranger
      notifications_enabled
      title
      team {
        is_enabled
        can_do_premium_things
        is_chrome_extension_enabled
        team_id
        uuid
        team_name
        payment_subscription {
          customer_id
          product_name_slug
          subscription_name
        }
        channels {
          uuid
          name
          id
        }
        ...TeamUsersFields
      }
    }
  }
`;
